import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import Measurement from './routes/measurement/Measurement';
import Pvstatus from './routes/pvstatus/Pvstatus';
import Statistics from './routes/statistics/statistics';
import Alarm from './routes/alarm/alarm';
import Setting from './routes/admin/setting';
import VibrationDetection from './routes/VibrationDetection';
import Navbar from './public/Navbar';
import { Routes, Route } from 'react-router-dom';
import SchedulePage from './routes/schedule/SchedulePage';
import DiagramPage from './routes/diagram/DiagramPage';
import axios from 'axios';
import config from './config';
import LocalLicenseInput from './LocalLicense/LocalLicenseInput';
import LicenseAlarmModal from './LocalLicense/LicenseAlarmModal';

const LOCAL_LICENSE_FLOW_FINISHED_KEY = 'localLicenseFlowFinished';
const LICENSE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

function App() {
  const isLicenseFlowAlreadyFinished =
    localStorage.getItem(LOCAL_LICENSE_FLOW_FINISHED_KEY) === 'true';
  const [isCheckingLicense, setIsCheckingLicense] = useState(!isLicenseFlowAlreadyFinished);
  const [isUiLocked, setIsUiLocked] = useState(false);
  const [isLicenseChecked, setIsLicenseChecked] = useState(isLicenseFlowAlreadyFinished);
  const [showLicenseAlarm, setShowLicenseAlarm] = useState(false);
  const licenseStatusTimerRef = useRef(null);
  const isLicenseFlowFinishedRef = useRef(isLicenseFlowAlreadyFinished);

  const scheduleNextLicenseCheck = (nextCheckAfterMs) => {
    if (isLicenseFlowFinishedRef.current) {
      return;
    }

    if (licenseStatusTimerRef.current) {
      clearTimeout(licenseStatusTimerRef.current);
    }

    const delay = Number.isFinite(Number(nextCheckAfterMs))
      ? Math.max(5000, Number(nextCheckAfterMs))
      : LICENSE_CHECK_INTERVAL_MS;

    licenseStatusTimerRef.current = setTimeout(() => {
      checkLicenseStatus();
    }, delay);
  };

  // 라이센스 상태 체크
  const checkLicenseStatus = async () => {
    if (isLicenseFlowFinishedRef.current) {
      return;
    }

    try {
      const response = await axios.get(`${config.backendUrl}/api/local-license/status`);

      if (isLicenseFlowFinishedRef.current) {
        return;
      }

      const data = response.data || {};
      setIsUiLocked(data.is_registered === true && data.is_locked === true);
      setIsLicenseChecked(Number(data.is_license_check) === 1);
      setShowLicenseAlarm(data.should_show_license_alarm === true);
      scheduleNextLicenseCheck(data.nextCheckAfterMs);
    } catch (error) {
      if (isLicenseFlowFinishedRef.current) {
        return;
      }

      console.error('Failed to check local license status.', error);
      setIsUiLocked(false);
      setIsLicenseChecked(false);
      setShowLicenseAlarm(false);
      scheduleNextLicenseCheck(LICENSE_CHECK_INTERVAL_MS);
    } finally {
      setIsCheckingLicense(false);
    }
  };

  const finishLicenseFlow = () => {
    isLicenseFlowFinishedRef.current = true;
    localStorage.setItem(LOCAL_LICENSE_FLOW_FINISHED_KEY, 'true');

    if (licenseStatusTimerRef.current) {
      clearTimeout(licenseStatusTimerRef.current);
      licenseStatusTimerRef.current = null;
    }

    setShowLicenseAlarm(false);
    setIsLicenseChecked(true);
    setIsUiLocked(false);
  };

  useEffect(() => {
    if (!isLicenseFlowFinishedRef.current) {
      checkLicenseStatus();
    }

    return () => {
      if (licenseStatusTimerRef.current) {
        clearTimeout(licenseStatusTimerRef.current);
      }
    };
  }, []);

  if (isCheckingLicense) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        라이센스 상태 확인 중...
      </div>
    );
  }

  if (isUiLocked) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LocalLicenseInput onUnlocked={finishLicenseFlow} />
        {!isLicenseChecked && (
          <LicenseAlarmModal
            checked={isLicenseChecked}
            onCheckedChange={setIsLicenseChecked}
            onConfirm={() => setIsLicenseChecked(true)}
          />
        )}
      </div>
    );
  }


  return (
    <>
      <Routes>
        {/* Navbar를 포함하는 구조로 수정 */}
        <Route path="/" element={<Navbar />}>
          <Route index element={<Pvstatus />} />
          <Route path="pvstatus" element={<Pvstatus />} />
          <Route path="measurement" element={<Measurement />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="alarm" element={<Alarm />} />
          <Route path="vibrationDetection" element={<VibrationDetection />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="diagram" element={<DiagramPage />} />
        </Route>
        <Route path="admin" element={<Setting />} />
      </Routes>
      {showLicenseAlarm && (
        <LicenseAlarmModal
          checked={isLicenseChecked}
          onCheckedChange={setIsLicenseChecked}
          onConfirm={() => setShowLicenseAlarm(false)}
        />
      )}
    </>

  );
}

export default App;
